module.exports = __webpack_public_path__ + "5c66396ce5f5d3aa424db01489f84dd3.png";